(() => {
  const publish = (name, payload) => {
    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish(name, payload);
    }
  };

  const params = new URLSearchParams(window.location.search);
  const requestedPath = params.get('service');
  const validPaths = new Set(['personal-life', 'company-legacy', 'founder-campaign', 'pet-life']);
  const selector = validPaths.has(requestedPath)
    ? '[name="contact[Service path]"][value="' + requestedPath + '"]'
    : null;
  const pathInput = selector ? document.querySelector(selector) : null;
  if (pathInput) pathInput.checked = true;

  const source = document.querySelector('[data-cpo-source]');
  if (source) {
    const attribution = ['utm_source', 'utm_campaign', 'utm_content']
      .map((key) => params.get(key))
      .filter(Boolean)
      .join(' / ');
    source.value = attribution || requestedPath || 'homepage-direct';
  }

  document.querySelectorAll('[data-cpo-path]').forEach((link) => {
    link.addEventListener('click', () => {
      publish('story_path_selected', {
        path: link.dataset.cpoPath,
        placement: link.dataset.cpoPlacement || 'unknown',
      });
    });
  });

  document.querySelectorAll('[name="contact[Service path]"]').forEach((input) => {
    input.addEventListener('change', () => {
      publish('story_path_selected', { path: input.value, placement: 'apply-form' });
    });
  });

  document.querySelectorAll('.cpo-mobile-nav__panel a').forEach((link) => {
    link.addEventListener('click', () => {
      link.closest('details')?.removeAttribute('open');
    });
  });
})();
